import organizationData from "../utils/organizationData.json";

const images = require.context(`/public/assets/images`, true);
const flags = require.context(`/public/assets/fonts`, true);


export const dynamicImage = (image: string | undefined) => {
return images(`./${image}`);
};


export const dynamicImageflags = (image: string | undefined) => {
return flags(`./${image}`);
};


export const countryOptions = organizationData.countries
  .filter((c: any) => c.value)
  .map((country: any) => ({
    value: country.value,
    label: country.label,
    flag: country.flag,
  }));

export const calculationTypeOptions = [
  { value: "fixed", label: "Fixed" },
  { value: "percentage", label: "Percentage" },
  { value: "slab", label: "Slab" },
];